import styled from 'styled-components';

export const Box = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 50px;
    margin-bottom: 30px;
    position: relative;
`;

type Props = {
    $src: string;
}

export const AvatarImg = styled.div<Props>`
    position: relative;
    width: 200px;
    height: 200px;

    border-radius: 1000px;

    background-image: url("${({ $src }) => $src}");
    background-size: cover;
    background-position: center;
`;

export const NameBlock = styled.div`
    margin-top: 90px;
    text-align: center;
`;

export const GenderLabel = styled.div`
    font-size: 24px;
`;

export const NameLabel = styled.div`
    font-size: 40px;
    font-weight: bold;
    margin-bottom: 14px;
`;

export const ActionsBox = styled.div`
    margin-top: 22px;
    text-align: center;

    display: flex;
    flex-direction: row;
`;

export const ActionBox = styled.div`
    & + & {
        margin-left: 4px;
    }
`;

export const DescriptionHeader = styled.div`
    text-align: center;
    font-size: 18px;
    margin-top: 12px;
`;

export const DescriptionBox = styled.div`
    max-width: 400px;
    font-size: 16px;
    margin-top: 14px;
    word-break: break-word;
    white-space: pre-wrap;

    width: 100%;
    background-color: #efe6df;
    padding: 8px;
    border-radius: 4px;
`;
